import { toast } from 'vue-sonner';
import { t } from './i18n';

function resolveMessage(input: unknown, fallback: string): string {
  if (typeof input === 'string' && input.trim()) return input;
  if (input instanceof Error && input.message.trim()) return input.message;
  if (input && typeof input === 'object' && 'message' in input) {
    const message = String((input as { message?: unknown }).message || '').trim();
    if (message) return message;
  }
  return fallback;
}

export function notifySuccess(message: string): void {
  toast.success(t(message));
}

export function notifyError(input: unknown, fallback = 'Something went wrong'): void {
  toast.error(t(resolveMessage(input, fallback)));
}

export function notifyInfo(message: string): void {
  toast.info(t(message));
}

export function notifyWarning(message: string): void {
  toast.warning(t(message));
}

/** Neutral toast with one follow-up action (e.g. "Undo", "Start over"). */
export function notifyWithAction(message: string, actionLabel: string, onAction: () => void, duration = 6000): void {
  toast(t(message), { duration, action: { label: t(actionLabel), onClick: onAction } });
}
